/**
 * Created by Pawel Grzyb 01.04.2018
 *
 * RODO pages contains legal information.
 */

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rodo-page',
  templateUrl: './rodo-page.component.html',
  styleUrls: ['./rodo-page.component.scss']
})
export class RodoPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
